const SET_PRODUCTION_RECORD = (state, payload) => {
  state.results = payload;
}

export default {
  SET_PRODUCTION_RECORD
}